import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  makeStyles,
  IconButton,
  Grid,
  colors,
  TextField,
  Checkbox,
  FormGroup,
  FormControlLabel,
} from "@material-ui/core";


import Button from "../../../../../components/controls/Button";
import { useRef } from "react";
import ReactToPrint from "react-to-print";
import { useEffect } from "react";
import { sto } from "../../../../../Context/InshData";
import { style } from "../../../../../Fronts/Menues/st/cStyle";
import { useStylesLbl, useStylesTD } from "../../../../../St/comps/UseStyle";
import BarcodeFoundItemPrice from "./BarcodeFoundItemPrice";
import BarcodeFoundPrice from "./BarcodeFoundPrice";
import BarcodeFound from "./BarcodeFound";
import BarcodeItemsPrice from "./BarcodeItemsPrice";
import BarcodeAndPrice from "./BarcodeAndPrice";
import BarcodeOnly from "./BarcodeOnly";
import BarcodeFoundItemPrice2 from "./BarcodeFoundItemPrice2";
import BarcodeDate from "./BarcodeDate";
import BarcodeFoundItemDate from "./BarcodeFoundItemDate";
import moment from "moment";
import { useTranslation } from "react-i18next";
import BarcodeItemsFoundDate from "./BarcodeItemsFoundDate";

const useStyles = makeStyles((theme) => ({
  dialog: {
    padding: theme.spacing(2),
    position: "absolute",
    top: theme.spacing(4),
  },
  dialogTitle: {
    textAlign: "center",
  },
  dialogContent: {
    alignContent: "center",
    textAlign: "center",
    border: "1px solid #000",
    backgroundColor: "#eee",
  },
  dialogAction: {
    justifyContent: "center",
  },
  titleIcon: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.main,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      cursor: "default",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "8rem",
    },
  },
}));

class ComponentToPrintFoundItemPrice2 extends React.Component {
  state = {
    pwca: true,
  };
  constructor() {
    super();
  }

  render() {
    const styleTyg = {
      color: '#000',
      padding: '0.1mm',
      alignContent: 'center'
    };
    return (
      <Typography component="div" style={styleTyg}>
        <BarcodeFoundItemPrice2
          barcode={this.props.barcode}
          itemName={this.props.data.symbol}
          price={this.props.sale_price}
          maqas={this.props.maqas}
          permiCuCo={this.props.permiCuCo}
          tax={this.props.data.tax}
          AutoOptions={this.props.AutoOptions}
          showLogo={this.props.showLogo}
          showItem={this.props.showItem}
          data={this.props.data}

        />
      </Typography>
    );
  }
}

class ComponentToPrintItemsFoundDate extends React.Component {
  state = {
    pwca: true,
  };
  constructor() {
    super();
  }

  render() {
    const styleTyg = {
      color: '#000',
      padding: '0.1mm',
      alignContent: 'center'
    };
    return (
      <Typography component="div" style={styleTyg}>
        <BarcodeItemsFoundDate
          barcode={this.props.barcode}
          itemName={this.props.data.symbol}
          price={this.props.sale_price}
          maqas={this.props.maqas}
          permiCuCo={this.props.permiCuCo}
          tax={this.props.data.tax}
          AutoOptions={this.props.AutoOptions}
          showLogo={this.props.showLogo}
          showItem={this.props.showItem}
          data={this.props.data}
          expiry_date={this.props.useDate?this.props.dateData.dateEx:this.props.data.expiry_date}
          prody_date={this.props.useDate?this.props.dateData.datePre:this.props.data.prody_date}
        />
      </Typography>
    );
  }
}
class ComponentToPrintBarcodeFoundItemDate extends React.Component {
  state = {
    pwca: true,
  };
  constructor() {
    super();
  }

  render() {
    const styleTyg = {
      color: '#000',
      padding: '0.1mm',
      alignContent: 'center'
    };
    return (
      <Typography component="div" style={styleTyg}>
        <BarcodeFoundItemDate
          barcode={this.props.barcode}
          itemName={this.props.data.symbol}
          price={this.props.sale_price}
          maqas={this.props.maqas}
          permiCuCo={this.props.permiCuCo}
          tax={this.props.data.tax}
          AutoOptions={this.props.AutoOptions}
          showLogo={this.props.showLogo}
          showItem={this.props.showItem}
          data={this.props.data}
          expiry_date={this.props.useDate?this.props.dateData.dateEx:this.props.data.expiry_date}
          prody_date={this.props.useDate?this.props.dateData.datePre:this.props.data.prody_date}
        />
      </Typography>
    );
  }
}
class ComponentToPrintFoundItemPrice extends React.Component {
  state = {
    pwca: true,
  };
  constructor() {
    super();
  }

  render() {
    const styleTyg = {
      color: '#000',
      padding: '0.1mm',
      alignContent: 'center'
    };
    return (
      <Typography component="div" style={styleTyg}>
        <BarcodeFoundItemPrice
          barcode={this.props.barcode}
          itemName={this.props.data.symbol}
          price={this.props.sale_price}
          maqas={this.props.maqas}
          permiCuCo={this.props.permiCuCo}
          tax={this.props.data.tax}
          AutoOptions={this.props.AutoOptions}
          showLogo={this.props.showLogo}
          showItem={this.props.showItem}
          data={this.props.data}

        />
      </Typography>
    );
  }
}

class ComponentToPrintFoundrice extends React.Component {
  state = {
    pwca: true,
  };
  constructor() {
    super();
  }

  render() {
    const styleTyg = {
      color: '#000',
      padding: '0.1mm',
      alignContent: 'center'
    };
    return (
      <Typography component="div" style={styleTyg}>
        <BarcodeFoundPrice
          barcode={this.props.barcode}
          itemName={this.props.data.symbol}
          price={this.props.sale_price}
          maqas={this.props.maqas}
          permiCuCo={this.props.permiCuCo}
          tax={this.props.data.tax}
          AutoOptions={this.props.AutoOptions}
          showLogo={this.props.showLogo}
          showItem={this.props.showItem}
          data={this.props.data}

        />
      </Typography>
    );
  }
}

class ComponentToPrintFound extends React.Component {
  state = {
    pwca: true,
  };
  constructor() {
    super();
  }

  render() {
    const styleTyg = {
      color: '#000',
      padding: '0.1mm',
      alignContent: 'center'
    };
    return (
      <Typography component="div" style={styleTyg}>
        <BarcodeFound
          barcode={this.props.barcode}
          itemName={this.props.data.symbol}
          price={this.props.sale_price}
          maqas={this.props.maqas}
          permiCuCo={this.props.permiCuCo}
          tax={this.props.data.tax}
          AutoOptions={this.props.AutoOptions}
          showLogo={this.props.showLogo}
          showItem={this.props.showItem}
          data={this.props.data}

        />
      </Typography>
    );
  }
}

class ComponentToPrintItemsPrice extends React.Component {
  state = {
    pwca: true,
  };
  constructor() {
    super();
  }

  render() {
    const styleTyg = {
      color: '#000',
      padding: '0.1mm',
      alignContent: 'center'
    };
    return (
      <Typography component="div" style={styleTyg}>
        <BarcodeItemsPrice
          barcode={this.props.barcode}
          itemName={this.props.data.symbol}
          price={this.props.sale_price}
          maqas={this.props.maqas}
          permiCuCo={this.props.permiCuCo}
          tax={this.props.data.tax}
          AutoOptions={this.props.AutoOptions}
          showLogo={this.props.showLogo}
          showItem={this.props.showItem}
          data={this.props.data}

        />
      </Typography>
    );
  }
}

class ComponentToPrintPrice extends React.Component {
  state = {
    pwca: true,
  };
  constructor() {
    super();
  }

  render() {
    const styleTyg = {
      color: '#000',
      padding: '0.1mm',
      alignContent: 'center'
    };
    return (
      <Typography component="div" style={styleTyg}>
        <BarcodeAndPrice
          barcode={this.props.barcode}
          itemName={this.props.data.symbol}
          price={this.props.sale_price}
          maqas={this.props.maqas}
          permiCuCo={this.props.permiCuCo}
          tax={this.props.data.tax}
          AutoOptions={this.props.AutoOptions}
          showLogo={this.props.showLogo}
          showItem={this.props.showItem}
          data={this.props.data}

        />
      </Typography>
    );
  }
}

class ComponentToPrintBracodeOnly extends React.Component {
  state = {
    pwca: true,
  };
  constructor() {
    super();
  }

  render() {
    const styleTyg = {
      color: '#000',
      padding: '0.1mm',
      alignContent: 'center'
    };
    return (
      <Typography component="div" style={styleTyg}>
        <BarcodeOnly
          barcode={this.props.barcode}
          itemName={this.props.data.symbol}
          price={parseFloat(this.props.sale_price)}
          maqas={this.props.maqas}
          permiCuCo={this.props.permiCuCo}
          tax={this.props.data.tax}
          AutoOptions={this.props.AutoOptions}
          showLogo={this.props.showLogo}
          showItem={this.props.showItem}
          data={this.props.data}

        />
      </Typography>
    );
  }
}

class ComponentToPrintBracodeDate extends React.Component {
  state = {
    pwca: true,
  };
  constructor() {
    super();
  }

  render() {
    const styleTyg = {
      color: '#000',
      padding: '0.1mm',
      alignContent: 'center'
    };
    return (
      <Typography component="div" style={styleTyg}>
        <BarcodeDate
          barcode={this.props.barcode}
          itemName={this.props.data.symbol}
          price={this.props.sale_price}
          maqas={this.props.maqas}
          expiry_date={this.props.useDate?this.props.dateData.dateEx:this.props.data.expiry_date}
          prody_date={this.props.useDate?this.props.dateData.datePre:this.props.data.prody_date}
          permiCuCo={this.props.permiCuCo}
          tax={this.props.data.tax}
          AutoOptions={this.props.AutoOptions}
          showLogo={this.props.showLogo}
          showItem={this.props.showItem}
          data={this.props.data}

        />
      </Typography>
    );
  }
}

export default function BarcodeGenrateDialog(props) {
  const { open, data, setOpen, permiCuCo, barcode, sale_price, AutoOptions } = props;
  const componentRef = useRef();
  const componentRef02 = useRef();
  const componentRef04 = useRef();
  const clasTD = useStylesTD();



  const componentRefFoundItemPrice = useRef();
  const componentRefFoundItemPrice2 = useRef();
  const componentRefItemFoundDate = useRef();

  const componentRefFoundPrice = useRef();
  const componentRefFound = useRef();
  const componentRefItemPrice = useRef();
  const componentRefPrice = useRef();
  const componentRefBarcode = useRef();
  const componentRefBarcodeDate = useRef();
  const componentRefBarcodeFoundItemDate = useRef();


  const classes = useStyles();
  const maqasvalue = {
    widthScreen: 100,
    widthLebal: 60,
    wisthPaper: 80,
    margnTop: 2,
    margnBottom: 0,
    margnRight: 0,
    marginLeft: 0

  }
  const dataDate = {
    datePre: moment(new Date()).format('YYYY-MM-DD'),
    dateEx: moment(new Date()).format('YYYY-MM-DD'),
    days: 0,
  };
  const [maqas, setMaqas] = React.useState(maqasvalue);
  const [dateData, setDateDate] = React.useState(dataDate);

  const [showLogo, setShowLogo] = React.useState(false);
  const [showItem, setShowItem] = React.useState(false);
  const [useDate, setUseDate] = React.useState(false);
  const { t } = useTranslation(["forms", "translation"]);


  const claslbl = useStylesLbl();
  const onChangeDateData = (propName) => (event) => {
    if ( propName==="days"){
      const date=new Date(dataDate.datePre);
      const daysD=Number(event.target.value);
      const dy=String(date.getDate()).padStart(2,"0");
      const DayPre=Number(dy);
      date.setDate(date.getDate()+daysD>0?DayPre+daysD:0);
      setDateDate({ ...dateData,days: event.target.value ,dateEx:moment(date).format('YYYY-MM-DD')});
    }else{
      setDateDate({ ...dateData, [propName]: event.target.value });
    }
  };
  const onChangeData = (propName) => (event) => {
    setMaqas({ ...maqas, [propName]: event.target.value });
  };
  useEffect(() => {
    console.log("the sto is", data);
    console.log("the sale_price is", sale_price);

  });
  const pageStyle = `
  @page {
      size: ${maqas.widthLebal}mm 25mm,
  };
  @media all {
      .pageBreak {
          display: none
      }
  };
  
  @media print {
      .pageBreak {
          page-break-before: always;
      }
  }`;

  return (
    <Dialog justifyContent="center" open={open} classes={{ paper: classes.dialog }}>
      <DialogTitle className={classes.dialogTitle}>
        <Typography variant="h5">{t("barcode-print-screen")}</Typography>
        <br />

      </DialogTitle>
      {/* <DialogContent className={...classes.dialogContent,}> */}
      <DialogContent justifyContent="center" className={classes.dialogContent} style={{
        width: maqas.widthScreen < 100 ? "100mm" : `${maqas.widthScreen}mm`,
        backgroundColor: '#fff', alignContent: "center"
      }}
      >

        <Grid item container lg={12} md={12} sm={12} xs={12}>
          <Grid item lg={4} md={4} sm={4} xs={4} >
            <TextField
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              id="id"
              label={t("screen-width")}
              style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
              name="barcode"
              value={maqas.widthScreen}
              InputLabelProps={{ className: claslbl.clrBlackLblS }}
              InputProps={{ className: claslbl.clrBlackTxt }}
              onChange={onChangeData("widthScreen")} />
          </Grid>

          <Grid item lg={4} md={4} sm={4} xs={4} >
            <TextField
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              id="symbol"
              InputLabelProps={{ className: claslbl.clrBlackLblS }}
              InputProps={{ className: claslbl.clrBlackTxt }}
              label={t("label-width")}
              style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
              name="symbol"
              value={maqas.widthLebal}

              onChange={onChangeData("widthLebal")}
            />
          </Grid>
          <Grid item lg={4} md={4} sm={4} xs={4} >
            <TextField
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              id="id"
              InputLabelProps={{ className: claslbl.clrBlackLblS }}
              InputProps={{ className: claslbl.clrBlackTxt }}
              label={t("screen-width")}
              style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
              name="barcode"
              value={maqas.wisthPaper}
              onChange={onChangeData("wisthPaper")} />
          </Grid>
          <Grid item lg={3} md={3} sm={4} xs={4} >
            <TextField
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              id="margnTop"
              InputLabelProps={{ className: claslbl.clrBlackLblS }}
              InputProps={{ className: claslbl.clrBlackTxt }}
              label={t("top")}
              style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
              name="symbol"
              value={maqas.margnTop}

              onChange={onChangeData("margnTop")}
            />
          </Grid>
          <Grid item lg={3} md={3} sm={4} xs={4} >
            <TextField
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              id="margnTop"
              InputLabelProps={{ className: claslbl.clrBlackLblS }}
              InputProps={{ className: claslbl.clrBlackTxt }}
              label={t("right")}
              style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
              name="symbol"
              value={maqas.margnBottom}

              onChange={onChangeData("margnBottom")}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={4} xs={4} >
            <TextField
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              id="margnTop"
              InputLabelProps={{ className: claslbl.clrBlackLblS }}
              InputProps={{ className: claslbl.clrBlackTxt }}
              label={t("top")}
              style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
              name="symbol"
              value={maqas.margnTop}

              onChange={onChangeData("margnTop")}
            />
          </Grid>
          <Grid item lg={3} md={3} sm={4} xs={4} >
            <TextField
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              id="margnTop"
              InputLabelProps={{ className: claslbl.clrBlackLblS }}
              InputProps={{ className: claslbl.clrBlackTxt }}
              label={t("right")}
              style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
              name="symbol"
              value={maqas.margnBottom}

              onChange={onChangeData("margnBottom")}
            />
          </Grid>
          <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginBottom: "0.3rem" }} >
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    fullWidth
                    checked={showLogo}
                    onChange={(e) => {
                      setShowLogo(e.target.checked);
                    }}
                    name="showLogo"
                  />
                }
                size="small"
                color="primary"
                fontSize="small"
                label={t("logo-image")}
                InputLabelProps={{ className: claslbl.clrBlackLbl }}
                InputProps={{ className: clasTD.clrBlackTxt }}
              />
            </FormGroup>
          </Grid>
          <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginBottom: "0.3rem" }} >
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    fullWidth
                    checked={showItem}
                    onChange={(e) => {
                      setShowItem(e.target.checked);
                    }}
                    name="showLogo"
                  />
                }
                size="small"
                color="primary"
                fontSize="small"
                label={t("item-image")}
                InputLabelProps={{ className: claslbl.clrBlackLbl }}
                InputProps={{ className: clasTD.clrBlackTxt }}
              />
            </FormGroup>
          </Grid>
          <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginBottom: "0.3rem" }} >
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    fullWidth
                    checked={useDate}
                    onChange={(e) => {
                      setUseDate(e.target.checked);
                    }}
                    name="showLogo"
                  />
                }
                size="small"
                color="primary"
                fontSize="small"
                label={t("use-date")}
                InputLabelProps={{ className: claslbl.clrBlackLbl }}
                InputProps={{ className: clasTD.clrBlackTxt }}
              />
            </FormGroup>
          </Grid>
          {useDate &&
            (
              <>
                <Grid item lg={8} md={8} sm={8} xs={4} >
                  <TextField
                    // type="date"
                    fullWidth
                    variant="outlined"
                    size="small"
                    id="id"
                    type="date" format="YYYY-MM-DD"
                    InputLabelProps={{ className: claslbl.clrBlackLblS }}
                    InputProps={{ className: claslbl.clrBlackTxt }}
                    label={t("forms:expiry-date")}
                    style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                    name="datePre"
                    value={dateData.datePre}
                    onChange={onChangeDateData("datePre")} />
                </Grid>
                <Grid item lg={4} md={4} sm={4} xs={4} >
                  <TextField
                    type="number"
                    fullWidth
                    variant="outlined"
                    size="small"
                    id="id"
                    InputLabelProps={{ className: claslbl.clrBlackLblS }}
                    InputProps={{ className: claslbl.clrBlackTxt }}
                    label={t("days")}
                    style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                    name="barcode"
                    value={dateData.days}
                    onChange={onChangeDateData("days")} />
                </Grid>
              </>
            )}
        </Grid>

        <div justifyContent="center" className={classes.dialogContent} style={{
          width: maqas.widthLebal < 50 ? "50mm" : `${maqas.widthLebal}mm`,
          backgroundColor: '#fff', alignContent: "center",
        }}
        >
          <ComponentToPrintFoundItemPrice2 ref={componentRefFoundItemPrice2} {...{ data, maqas, permiCuCo, barcode, sale_price, AutoOptions, showLogo, showItem,useDate,dateData }} />
        </div>
        <ReactToPrint justifyContent="center"
          trigger={() => (
            <Button
              text={t("print")}
              size="small"
              color="secondary"
              variant="outlined"
            />
          )}
          content={() => componentRefFoundItemPrice2.current}
          pageStyle={pageStyle}
        />


<div justifyContent="center" className={classes.dialogContent} style={{
          width: maqas.widthLebal < 50 ? "50mm" : `${maqas.widthLebal}mm`,
          backgroundColor: '#fff', alignContent: "center",
        }}
        >
          <ComponentToPrintItemsFoundDate ref={componentRefItemFoundDate} {...{ data, maqas, permiCuCo, barcode, sale_price, AutoOptions, showLogo, showItem,useDate,dateData }} />
        </div>
        <ReactToPrint justifyContent="center"
          trigger={() => (
            <Button
              text={t("print")}
              size="small"
              color="secondary"
              variant="outlined"
            />
          )}
          content={() => componentRefItemFoundDate.current}
          pageStyle={pageStyle}
        />

        <div justifyContent="center" className={classes.dialogContent} style={{
          width: maqas.widthLebal < 50 ? "50mm" : `${maqas.widthLebal}mm`,
          backgroundColor: '#fff', alignContent: "center",
        }}
        >
          <ComponentToPrintBarcodeFoundItemDate ref={componentRefBarcodeFoundItemDate} {...{ data, maqas, permiCuCo, barcode, sale_price, AutoOptions, showLogo, showItem,useDate,dateData  }} />
        </div>
        <ReactToPrint justifyContent="center"
          trigger={() => (
            <Button
              text={t("print")}
              size="small"
              color="secondary"
              variant="outlined"
            />
          )}
          content={() => componentRefBarcodeFoundItemDate.current}
          pageStyle={pageStyle}
        />
        <div justifyContent="center" className={classes.dialogContent} style={{
          width: maqas.widthLebal < 50 ? "50mm" : `${maqas.widthLebal}mm`,
          backgroundColor: '#fff', alignContent: "center"
        }}
        >
          <ComponentToPrintFoundrice ref={componentRefFoundPrice} {...{ data, maqas, permiCuCo, barcode, sale_price, AutoOptions, showLogo, showItem,useDate,dateData  }} />
        </div>
        <ReactToPrint justifyContent="center"
          trigger={() => (
            <Button
              text={t("print")}
              size="small"
              color="secondary"
              variant="outlined"
            />
          )}
          content={() => componentRefFoundPrice.current}
          pageStyle={pageStyle}
        />
        <div justifyContent="center" className={classes.dialogContent} style={{
          width: maqas.widthLebal < 50 ? "50mm" : `${maqas.widthLebal}mm`,
          backgroundColor: '#fff', alignContent: "center"
        }}
        >
          <ComponentToPrintFound ref={componentRefFound} {...{ data, maqas, permiCuCo, barcode, sale_price, AutoOptions, showLogo, showItem,useDate,dateData  }} />
        </div>
        <ReactToPrint
          trigger={() => (
            <Button
              text={t("print")}
              size="small"
              color="secondary"
              variant="outlined"
            />
          )}
          content={() => componentRefFound.current}
          pageStyle={pageStyle}
        />


        <div justifyContent="center" className={classes.dialogContent} style={{
          width: maqas.widthLebal < 50 ? "50mm" : `${maqas.widthLebal}mm`,
          backgroundColor: '#fff', alignContent: "center",
        }}
        >
          <ComponentToPrintItemsPrice ref={componentRefItemPrice} {...{ data, maqas, permiCuCo, barcode, sale_price, AutoOptions, showLogo, showItem ,useDate,dateData }} />
        </div>
        <ReactToPrint justifyContent="center"
          trigger={() => (
            <Button
              text={t("print")}
              size="small"
              color="secondary"
              variant="outlined"
            />
          )}
          content={() => componentRefItemPrice.current}
          pageStyle={pageStyle}
        />

        <div justifyContent="center" className={classes.dialogContent} style={{
          width: maqas.widthLebal < 50 ? "50mm" : `${maqas.widthLebal}mm`,
          backgroundColor: '#fff', alignContent: "center",
        }}
        >
          <ComponentToPrintPrice ref={componentRefPrice} {...{ data, maqas, permiCuCo, barcode, sale_price, AutoOptions, showLogo, showItem,useDate,dateData  }} />
        </div>
        <ReactToPrint justifyContent="center"
          trigger={() => (
            <Button
              text={t("print")}
              size="small"
              color="secondary"
              variant="outlined"
            />
          )}
          content={() => componentRefPrice.current}
          pageStyle={pageStyle}
        />

        <div justifyContent="center" className={classes.dialogContent} style={{
          width: maqas.widthLebal < 50 ? "50mm" : `${maqas.widthLebal}mm`,
          backgroundColor: '#fff', alignContent: "center",
        }}
        >
          <ComponentToPrintBracodeOnly ref={componentRefBarcode} {...{ data, maqas, permiCuCo, barcode, sale_price, AutoOptions, showLogo, showItem ,useDate,dateData }} />
        </div>
        <ReactToPrint justifyContent="center"
          trigger={() => (
            <Button
              text={t("print")}
              size="small"
              color="secondary"
              variant="outlined"
            />
          )}
          content={() => componentRefBarcode.current}
          pageStyle={pageStyle}
        />
        <div justifyContent="center" className={classes.dialogContent} style={{
          width: maqas.widthLebal < 50 ? "50mm" : `${maqas.widthLebal}mm`,
          backgroundColor: '#fff', alignContent: "center",
        }}
        >
          <ComponentToPrintBracodeDate ref={componentRefBarcodeDate} {...{ data, maqas, permiCuCo, barcode, sale_price, AutoOptions, showLogo, showItem ,useDate,dateData }} />
        </div>
        <ReactToPrint justifyContent="center"
          trigger={() => (
            <Button
              text={t("print")}
              size="small"
              color="secondary"
              variant="outlined"
            />
          )}
          content={() => componentRefBarcodeDate.current}
          pageStyle={pageStyle}
        />

      </DialogContent>
      {/* <DialogContent className={classes.dialogContent}></DialogContent> */}
      <DialogActions className={classes.dialogAction}>
        <Button text={t("close")} color="secondary" onClick={() => setOpen(false)} />
        <ReactToPrint
          trigger={() => <Button text={t("print")} color="secondary" />}
          content={() => componentRefItemPrice.current}
        />
      </DialogActions>
    </Dialog>
  );
}
